/**
 * @generated SignedSource<<46c900823d6b0789b1a68edc58c37501>>
 * @relayHash b59047dcf53aef0ea8350915bc6a8213
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b59047dcf53aef0ea8350915bc6a8213

import type { ConcreteRequest } from 'relay-runtime';
export type useIssueFormSecondaryQuery$variables = {
  id: string;
};
export type useIssueFormSecondaryQuery$data = {
  readonly node: {
    readonly codeOfConductFileUrl?: string | null | undefined;
    readonly contributingFileUrl?: string | null | undefined;
    readonly securityPolicyUrl?: string | null | undefined;
    readonly supportFileUrl?: string | null | undefined;
  } | null | undefined;
};
export type useIssueFormSecondaryQuery = {
  response: useIssueFormSecondaryQuery$data;
  variables: useIssueFormSecondaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "securityPolicyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contributingFileUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "codeOfConductFileUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportFileUrl",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useIssueFormSecondaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIssueFormSecondaryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "b59047dcf53aef0ea8350915bc6a8213",
    "metadata": {},
    "name": "useIssueFormSecondaryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "31aa1503eb5e95982e5aa8c08b4be6c9";

export default node;
